var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-export",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.312 4H7v4.5c0 .275.23.5.508.5h1C8.784 9 9 8.775 9 8.5V4h1.703c.297 0 .394-.265.215-.5L8.33.178c-.178-.235-.467-.24-.645-.004L5.098 3.5c-.18.236-.082.5.214.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5c0 .276.23.5.508.5H14v3H2V9h2.508C4.784 9 5 8.776 5 8.5v-1c0-.276-.216-.5-.492-.5h-3.5C.455 7 0 7.447 0 8v7c0 .553.455 1 1.008 1h14c.553 0 .992-.447.992-1V8c0-.553-.44-1-.992-1h-3.5c-.277 0-.508.224-.508.5v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.014319eccb0d6069839a0af5c383e8cc.svg";
export { ForwardRef as ReactComponent };